import styled from "styled-components"
import {
  REVIEW_REASON_COPY,
  REVIEW_REASON_FALLBACK_COPY,
} from "~constants/proofOfOwnership"

interface AIReviewReasonNoteProps {
  reviewReason: string
}

// A thin amber note rendered above the (green) validate suggestion. The validate
// box itself only says "looks valid and ready to approve"; for a NEEDS_REVIEW
// document that carries data, this note explains WHY it still reached the
// operator — what to double-check (LOW_CONFIDENCE, ENTITY_HOLDER, ESCALATION_
// UNAVAILABLE) or fill in before accepting (SHARE_QUANTITY_NOT_FOUND, DATE_NOT_
// FOUND). Unknown codes fall back to a generic line (forward-compat).
const AIReviewReasonNote = ({ reviewReason }: AIReviewReasonNoteProps) => {
  const copy = REVIEW_REASON_COPY[reviewReason] || REVIEW_REASON_FALLBACK_COPY

  return (
    <Container role="note">
      <Icon aria-hidden>⚠️</Icon>
      <Text>
        <Label>Needs review</Label> {copy}
      </Text>
    </Container>
  )
}

const Container = styled.div`
  display: flex;
  align-items: center;
  gap: 8px;
  margin-bottom: 8px;
  padding: 8px 14px;
  border-radius: 8px;
  background: #fffbeb;
  border: 1px solid #fde68a;
`

const Icon = styled.span`
  flex-shrink: 0;
  font-size: 14px;
  line-height: 1;
`

const Text = styled.div`
  flex: 1;
  min-width: 0;
  font-size: 13px;
  font-weight: 400;
  color: #92400e;
`

const Label = styled.span`
  font-weight: 700;
  text-transform: uppercase;
  letter-spacing: 0.5px;
  font-size: 11px;
  color: #b45309;
  margin-right: 2px;
`

export default AIReviewReasonNote
